import axios from "../utils/axios";
import * as api from "./api";

export function login(params) {
    return new Promise((resolve, reject) => {
        axios.post(api.USER_LOGIN, params)
            .then(response => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.log('catch login ', error)
                reject(error);
            })
    })
}

export function isLogin() {
    return new Promise((resolve, reject) => {
        axios.post(api.USER_IS_LOGIN)
            .then(response => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.log('catch isLogin ', error)
                reject(error);
            })
    })
}


export function logout(params) {
    return new Promise((resolve, reject) => {
        axios.post(api.USER_LOGOUT, params)
            .then(response => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.log('catch logout ', error)
                reject(error);
            })
    })
}


export function sendVCode(params) {
    return new Promise((resolve, reject) => {
        axios.get(api.USER_SEND_VCODE, {params})
            .then(response => {
                resolve(response.data);
            })
            .catch((error) => {
                console.log('catch send VCode ', error)
                reject(error);
            })
    })
}


